import React from "react";

export interface InstituteDetailsFieldItem {
	name: string;
	label: string;
	icon: React.ReactNode;
	value: string;
}

interface InstituteDetailsFieldGridProps {
	fields: InstituteDetailsFieldItem[];
	columnsClassName?: string;
}

const InstituteDetailsFieldGrid: React.FC<InstituteDetailsFieldGridProps> = ({
	fields,
	columnsClassName = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
}) => (
	<div className={`grid ${columnsClassName} gap-3`}>
		{fields.map(field => (
			<div
				key={field.name}
				className="flex items-center gap-3 p-2 rounded-lg bg-white border border-gray-200 hover:border-gray-300 transition-all duration-200 shadow-sm hover:shadow-md">
				<div className="flex-shrink-0 w-8 h-8 bg-gray-400 rounded-lg flex items-center justify-center shadow-sm">
					<div className="text-white text-base drop-shadow-sm">{field.icon}</div>
				</div>
				<div className="flex-1 min-w-0">
					<div className="text-sm font-semibold text-gray-900 tracking-wide mb-1">
						{field.label}
						<span className="text-red-500 ml-1">*</span>
					</div>
					<div className="text-sm font-medium text-gray-500 break-words">{field.value}</div>
				</div>
			</div>
		))}
	</div>
);

export default InstituteDetailsFieldGrid;
